import { SECTIONS } from '../data/sections';
import { ROLES } from '../data/roles';

export function getSectionProgress(progress, sectionKey) {
  const p = progress[sectionKey] || {};
  const checklist = SECTIONS[sectionKey]?.checklist || [];
  const total = checklist.length;
  const done    = Object.values(p).filter(v => v?.status === 'Done').length;
  const blocked = Object.values(p).filter(v => v?.status === 'Blocked').length;
  const inProg  = Object.values(p).filter(v => v?.status === 'In Progress').length;
  const pct     = total ? Math.round((done / total) * 100) : 0;
  return { total, done, blocked, inProg, pct };
}

export function getPhaseProgress(progress, phaseKeys, roleSections) {
  const relevant = phaseKeys.filter(k => roleSections.includes(k));
  if (!relevant.length) return null;
  let total = 0, done = 0;
  relevant.forEach(k => {
    const p = getSectionProgress(progress, k);
    total += p.total;
    done  += p.done;
  });
  return { total, done, pct: total ? Math.round((done / total) * 100) : 0, count: relevant.length };
}

export function getOverallProgress(progress, roleKey) {
  const role = ROLES[roleKey];
  if (!role) return { total: 0, done: 0, blocked: 0, inProg: 0, pct: 0 };
  let total = 0, done = 0, blocked = 0, inProg = 0;
  role.sections.forEach(k => {
    const p = getSectionProgress(progress, k);
    total   += p.total;
    done    += p.done;
    blocked += p.blocked;
    inProg  += p.inProg;
  });
  const pct = total ? Math.round((done / total) * 100) : 0;
  return { total, done, blocked, inProg, pct };
}

export function getPctColor(pct, fallbackColor = '#1F4E79') {
  if (pct === 100) return '#375623';
  if (pct > 0)    return '#854F0B';
  return fallbackColor;
}

export function getStepStatus(progress, sectionKey, stepIndex) {
  return progress?.[sectionKey]?.[stepIndex]?.status || 'Not Started';
}

export function pillClass(status) {
  switch (status) {
    case 'Done':        return 'pill pill-done';
    case 'In Progress': return 'pill pill-progress';
    case 'Blocked':     return 'pill pill-blocked';
    case 'N/A':         return 'pill pill-na';
    default:            return 'pill pill-default';
  }
}

export function numClass(status) {
  switch (status) {
    case 'Done':        return 'step-num num-done';
    case 'In Progress': return 'step-num num-progress';
    case 'Blocked':     return 'step-num num-blocked';
    default:            return 'step-num num-default';
  }
}
